import NotFoundPage from './ui/NotFoundPage';
export default NotFoundPage;
